import { Component, OnInit, ViewChild } from '@angular/core'
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component'
import { WbsService } from 'src/app/services/wbs.service'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { FrontEndParams } from '@interserve/igx-angular'
import { environment } from 'src/environments/environment'
import { IsAccountService } from '@interserve/angular'

@Component({
    selector: 'app-create-area-owner',
    templateUrl: './create-area-owner.component.html',
    styleUrls: ['./create-area-owner.component.scss'],
})
export class CreateAreaOwnerComponent implements OnInit {
    @ViewChild('snackbar', { static: true }) private snackbar!: SnackbarComponent

    public frontendCd = 'areaOwnerMappingV3'
    public frontendCdHub = 'areaUserMappingNamecardHubV3'
    public title = 'ドキュメント管理／エリアユーザー(所有者)紐づけ'

    environmentKey = environment.environmentKey

    public apiLoading = false
    public loading = false

    public customerId = ''
    public areaId = ''

    //紐づけライブラリ用
    public mappingParams!: FrontEndParams
    public hubParams!: FrontEndParams

    constructor(
        private wbsService: WbsService,
        private isAccountService: IsAccountService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.customerId = this.isAccountService.account?.customerId ?? ''

        this.route.paramMap.subscribe((params: ParamMap) => {
            this.areaId = params.get('areaId') ?? ''
        })

        this.initialize()
    }
    async initialize() {
        this.loading = true
        try {
            //フロントエンド設定を紐づけに渡す
            let param = { customerId: this.customerId, areaId: this.areaId, payload: {} }
            this.mappingParams = this.wbsService.setFrontendParams(this.frontendCd, param)
            this.hubParams = this.wbsService.setFrontendParams(this.frontendCdHub, param)
            this.hubParams = {
                appCd: 'documentWbs',
                layoutFrontendCd: this.frontendCdHub,
                items: param,
            }

            this.loading = false
        } catch (error) {
            this.snackbar.error('画面の初期化が失敗しました')
            this.loading = false
        }
    }
    gotoArea() {
        this.router.navigate([`settings/select-area-for-areauser`])
    }
}
